module.exports=function(scope){ return `<div class="dt-gnm-menu-button__container">
    <span class="dt-gnm-menu-button__title"></span>
      <div class="dt-gnm-menu-button__detail">
        <div class="dt-gnm-menu-button__current_option"></div>
        ${scope.caretIcon}
      </div>
</div>`};


// WEBPACK FOOTER //
// ./src/templates/global-menu-button.tpl.html